module.exports = "/_next/static/images/pin-ac11616b6de34c25a4cd33fe0fd22f42.svg";